<template>
    <div
        v-if="!noFiltersToDisplay"
        class="rounded border border-solid border-2 border-default-1 px-1 hidden-xs-down"
        :class="{busy: loading}">

        <div class="d-flex flex-wrap flex-justify-center">

            <CatalogFilterGroupDesktop
                v-if="!$scope.IS_REGULAR_CUSTOMER"
                label="Tipo de produção"
                class="mr my-1"
                :value="selected.inPhysicalStock">
                <CatalogFilterGroupOption
                    v-for="stock in filters.stock_filter"
                    :key="stock.id"
                    :value="stock.id"
                    :label="stock.name"
                    url-param="inPhysicalStock"/>
            </CatalogFilterGroupDesktop>

            <CatalogFilterGroupDesktop
                v-if="displayFilterTypes"
                label="Tipo"
                class="mr my-1"
                :value="selectedTypeId">
                <CatalogFilterGroupOption
                    v-show="selected.type_id && selected.type_id < 500"
                    :value="undefined"
                    label="Todos"
                    :link="selected.type_url"
                    url-param="tipo"/>
                <CatalogFilterGroupOption
                    v-for="type in filters.types"
                    v-show="type.count > 0"
                    :key="type.id"
                    :count="type.count"
                    :value="type.id"
                    :label="type.name"
                    :link="type.url"
                    url-param="tipo"/>
            </CatalogFilterGroupDesktop>

            <CatalogFilterGroupDesktop
                v-if="displayFilterGenders"
                label="Gênero"
                class="mr my-1"
                :value="selected.gender">
                <CatalogFilterGroupOption
                    :value="undefined"
                    label="Todos"
                    :link="selected.gender_url"
                    url-param="genero"/>
                <CatalogFilterGroupOption
                    v-for="gender in filters.genders"
                    v-show="gender.count > 0"
                    :key="gender.id"
                    :value="gender.id"
                    :label="gender.name"
                    :link="gender.url"
                    url-param="genero"/>
            </CatalogFilterGroupDesktop>

            <CatalogFilterGroupDesktop
                v-if="displayFilterSizesAdult || displayFilterSizesChild || displayFilterSizes"
                label="Tamanho"
                class="mr my-1"
                :value="selected.size">
                <CatalogFilterGroupOption
                    :value="undefined"
                    label="Todos"
                    url-param="tamanho"
                    :handle-fetch="false"
                    @fetch="$emit('filter-all-sizes', $event)"/>
                <div v-if="displayFilterSizesAdult">
                    <hr class="my-2"/>
                    <div class="text-secondary ml-4">
                        Adulto
                    </div>
                    <CatalogFilterGroupOption
                        v-for="size in filters.sizes_adult"
                        v-show="size.count > 0"
                        :key="size.name"
                        :value="size.name"
                        :label="size.name"
                        :link="size.name"
                        url-param="tamanho"
                        :handle-fetch="false"
                        @fetch="$emit('filter-size', size, $event)"/>
                </div>
                <div v-if="displayFilterSizesChild">
                    <hr class="my-2"/>
                    <div class="text-secondary ml-4">
                        Infantil
                    </div>
                    <CatalogFilterGroupOption
                        v-for="size in filters.sizes_child"
                        v-show="size.count > 0"
                        :key="size.name"
                        :value="size.name"
                        :label="size.name"
                        :link="size.name"
                        url-param="tamanho"
                        :handle-fetch="false"
                        @fetch="$emit('filter-size', size, $event)"/>
                </div>
            </CatalogFilterGroupDesktop>

            <CatalogFilterGroupDesktop
                v-if="displayFilterColors"
                label="Cor"
                class="mr my-1"
                :value="selected.color">
                <CatalogFilterGroupOption
                    :value="undefined"
                    label="Todas"
                    :link="selected.color_url"
                    url-param="cor"/>
                <CatalogFilterGroupOption
                    v-for="color in filters.colors"
                    v-if="color.id && color.id !== 14"
                    :key="color.id"
                    :value="color.id"
                    :label="color.name"
                    :hex="color.rgb"
                    :link="color.url"
                    url-param="cor"/>
            </CatalogFilterGroupDesktop>

            <div
                class="hidden-md-down hidden-lg-up"
                style="flex: 1 1 100%; height: 0"/>

            <CatalogFilterGroupDesktop
                v-if="displayFilterPrices"
                label="Preço"
                class="mr my-1"
                :value="selected.price">
                <CatalogFilterGroupOption
                    :value="undefined"
                    label="Todos"
                    :link="selected.price"
                    url-param="preco"/>
                <CatalogFilterGroupOption
                    v-for="price in filters.prices"
                    v-show="price.count > 0"
                    :key="price.id"
                    :label="getPriceLabel(price)"
                    :count="price.count"
                    :value="price.id"
                    :link="price.id"
                    url-param="preco"/>
            </CatalogFilterGroupDesktop>

            <CatalogFilterGroupDesktop
                v-if="displayFilterCategories"
                :label="hasCollections ? 'Categoria' : 'Tema'"
                class="mr my-1"
                :value="selected.category">

                <CatalogFilterGroupOption
                    :value="undefined"
                    label="Todas"
                    :link="selected.category_url"
                    url-param="categoria"/>

                <div v-if="hasCollections">
                    <hr class="my-2"/>
                    <div class="text-secondary ml-4">
                        Coleções Exclusivas
                    </div>
                    <CatalogFilterGroupOption
                        v-for="collection in filters.collections"
                        v-show="collection.count > 0"
                        :key="collection.id"
                        :count="collection.count"
                        :value="collection.id"
                        :label="collection.name"
                        :link="collection.url"
                        url-param="categoria"/>
                </div>

                <div v-if="hasCategories">
                    <div v-if="hasCollections">
                        <hr class="my-2"/>
                        <div class="text-secondary ml-4">
                            Temas
                        </div>
                    </div>
                    <CatalogFilterGroupOption
                        v-for="category in filters.categories"
                        v-show="category.count > 0"
                        :key="category.id"
                        :count="category.count"
                        :value="category.id"
                        :label="category.name"
                        :link="category.url"
                        url-param="categoria"/>
                </div>
            </CatalogFilterGroupDesktop>

            <div class="hidden-lg-down"
                 style="flex: 1 1 100%; height: 0"/>

            <template v-if="displayMulticolorFilter">
                <div
                    class="catalog-filter-check mr my-1 d-flex flex-align-center"
                    @click.stop.prevent="$emit('toggle-multiple-fabrics')">
                    <div>
                        <input
                            id="catalog-filter-multiple-colors-desktop"
                            type="checkbox"
                            class="cr-checkbox"
                            :checked="multipleFabricsSelected">
                        <label for="catalog-filter-multiple-colors-desktop">
                            Com várias cores
                        </label>
                    </div>
                </div>

                <div
                    v-if="displayInPhysicalStock || displaySelected"
                    class="bg-default-1 mr my-2 hidden-lg-down"
                    style="flex: 0 0 2px"/>
            </template>

            <template v-if="displayInPhysicalStock">
                <div
                    class="catalog-filter-check my-1 d-flex flex-align-center"
                    :class="{mr: displaySelected}">
                    <div class="d-flex flex-align-center">
                        <div @click.stop.prevent="$emit('toggle-delivery-ready')">
                            <input
                                id="catalog-filter-delivery-ready-desktop"
                                type="checkbox"
                                class="cr-checkbox"
                                :checked="deliveryReadySelected">
                            <label for="catalog-filter-delivery-ready-desktop">
                                Com pronta entrega
                                <div v-show="showDeliveryReadyWarning"
                                     class="text-warning-4">
                                    Selecione um tamanho
                                </div>
                            </label>
                        </div>
                        <span @click="$emit('delivery-ready-info')">
                        <i class="cursor-pointer icon-cr icon-question-sign"></i>
                    </span>
                    </div>
                </div>

                <div
                    v-if="displaySelected"
                    class="bg-default-1 mr my-2 hidden-lg-down"
                    style="flex: 0 0 2px"/>

            </template>

            <template v-if="displaySelected">
                <a
                    class="catalog-filter-check my-1 text-underline d-flex flex-align-center"
                    :href="mainUrl"
                    @click="resetFilters">
                    <div>Limpar filtros</div>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
    import CatalogFilterGroupDesktop from "./CatalogFilterGroupDesktop";
    import CatalogFilterGroupOption from "./CatalogFilterGroupOption";
    import CatalogFilters from "./CatalogFilters";

    export default {
        name: "CatalogFiltersDesktop",

        extends: CatalogFilters,

        components: {CatalogFilterGroupOption, CatalogFilterGroupDesktop},
    }
</script>